import { Transfer } from './model';
import { TransferDefault } from './defaults';
import { UserInfo } from '../../../models';
import { PKey } from '../../devices';

const defaultState: Transfer = TransferDefault;

export const setDevices = (
  state = defaultState,
  devices: PKey[]
): Transfer => ({ ...state, devices });

export const setReciever = (
  state = defaultState,
  receiver: UserInfo
): Transfer => ({ ...state, receiver });

